export default __webpack_public_path__ + "static/media/owl.dfc0fdb7.svg";